export const CONTACT_US_LINK_ENV = process.env.REACT_APP_CONTACT_US_LINK